(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-navigation-behaviour"] && !Shopify.designMode) return;
  try {
    (() => {
  if (document.documentElement.dataset.ccNavigationBound) return;
  document.documentElement.dataset.ccNavigationBound = 'true';
  const desktop = matchMedia('(min-width: 1001px)');
  let serial = 0;
  let hoverTimer;
  const initializedItems = new WeakSet();
  function setup(root = document) {
    root.querySelectorAll('[data-cc-nav-item]').forEach(item => {
      if (initializedItems.has(item)) return;
      const panel = item.querySelector(':scope > .cc-nav-panel');
      if (!panel) return;
      initializedItems.add(item);
      panel.id = `cc-navigation-${++serial}`;
      item.querySelectorAll(':scope > a').forEach(trigger => {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-controls', panel.id);
        trigger.setAttribute('aria-expanded', String(item.classList.contains('cc-open')));
      });
      item.querySelectorAll('.cc-menu-group').forEach(group => {
        const links = group.querySelector('.cc-group-links');
        const toggle = group.querySelector('.cc-group-toggle');
        if (!toggle || !links) return;
        links.id = `cc-navigation-group-${++serial}`;
        toggle.setAttribute('aria-controls', links.id);
        toggle.querySelector('span').textContent = group.classList.contains('is-expanded') ? '−' : '+';
      });
    });
  }
  function setOpen(item, open, returnFocus = false) {
    if (!item) return;
    if (open) {
      document.querySelectorAll('[data-cc-nav-item].cc-open').forEach(other => { if (other !== item) setOpen(other, false); });
      const bottom = item.querySelector('.cc-nav-trigger').getBoundingClientRect().bottom;
      item.style.setProperty('--cc-menu-room', `${Math.max(180, innerHeight - bottom - 18)}px`);
    }
    item.classList.toggle('cc-open', open);
    if (!open) item.classList.remove('hover', 'toggle', 'mtoggle');
    item.querySelectorAll(':scope > a').forEach(a => a.setAttribute('aria-expanded', String(open)));
    if (returnFocus) item.querySelector('.cc-nav-trigger').focus();
  }
  document.addEventListener('click', event => {
    const serviceBack = event.target.closest('[data-cc-service-back]');
    if (serviceBack) {
      event.preventDefault(); event.stopImmediatePropagation();
      setOpen(serviceBack.closest('[data-cc-nav-item]'), false, true);
      return;
    }
    const groupToggle = event.target.closest('.cc-group-toggle');
    if (groupToggle) {
      event.preventDefault(); event.stopImmediatePropagation();
      const group = groupToggle.closest('.cc-menu-group');
      const expanded = group.classList.toggle('is-expanded');
      groupToggle.setAttribute('aria-expanded', String(expanded));
      groupToggle.querySelector('span').textContent = expanded ? '−' : '+';
      return;
    }
    const trigger = event.target.closest('.cc-nav-trigger, .cc-nav-item > a.toggle');
    if (trigger) {
      event.preventDefault(); event.stopImmediatePropagation(); clearTimeout(hoverTimer);
      const item = trigger.closest('[data-cc-nav-item]');
      setOpen(item, !item.classList.contains('cc-open'));
      return;
    }
    if (!event.target.closest('[data-cc-nav-item]')) document.querySelectorAll('[data-cc-nav-item].cc-open').forEach(item => setOpen(item, false));
  }, true);
  document.addEventListener('keydown', event => {
    const item = event.target.closest('[data-cc-nav-item]');
    if (!item) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); setOpen(item, false, true); }
    if (event.target.matches('.cc-nav-trigger, .cc-nav-item > a.toggle') && [' ', 'ArrowDown'].includes(event.key)) {
      event.preventDefault(); event.stopImmediatePropagation();
      setOpen(item, event.key === 'ArrowDown' || !item.classList.contains('cc-open'));
      if (event.key === 'ArrowDown') item.querySelector('.cc-nav-panel a').focus();
    }
  }, true);
  document.addEventListener('pointerover', event => {
    if (!desktop.matches || event.pointerType !== 'mouse') return;
    const item = event.target.closest('[data-cc-nav-item]');
    if (item && !item.contains(event.relatedTarget)) { clearTimeout(hoverTimer); hoverTimer = setTimeout(() => setOpen(item, true), 120); }
    if (!item && event.target.closest('#nav > ul > li, #nav-bar > ul > li')) document.querySelectorAll('[data-cc-nav-item].cc-open').forEach(open => setOpen(open, false));
  });
  document.addEventListener('pointerout', event => {
    if (!desktop.matches || event.pointerType !== 'mouse') return;
    const item = event.target.closest('[data-cc-nav-item]');
    if (item && !item.contains(event.relatedTarget)) { clearTimeout(hoverTimer); hoverTimer = setTimeout(() => { if (!item.contains(document.activeElement)) setOpen(item, false); }, 180); }
  });
  document.addEventListener('focusout', event => {
    const item = event.target.closest('[data-cc-nav-item]');
    if (item) setTimeout(() => { if (!item.contains(document.activeElement) && !item.matches(':hover')) setOpen(item, false); }, 0);
  });
  desktop.addEventListener('change', () => {
    document.querySelectorAll('[data-cc-nav-item]').forEach(item => setOpen(item, false));
    if (desktop.matches && document.documentElement.classList.contains('m2a')) {
      document.querySelector('#nav > .close-nav')?.click();
      document.querySelectorAll('a[aria-controls="nav"]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    }
  });
  document.addEventListener('shopify:section:load', () => setup());
  function initialize() {
    setup();
    const header = document.querySelector('.shopify-section-header');
    if (header) new MutationObserver(records => { if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('[data-cc-nav-item]') || node.querySelector?.('[data-cc-nav-item]'))))) setup(); }).observe(header, {childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
